import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { useFormik } from "formik";
import React, { useContext, useEffect, useState } from "react";
import { ContextOperation } from "../../context/OperationContext";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import useSnackbar from "../../hooks/useSnackbar";
import MonySymbolsComponets from "../common/MonySymbolsComponents";
import { nameof } from "../common/ObjectUtils";
import { DriversTypes } from "./Types";
import FormInput from "../common/FormInput";
import { useForm } from "react-hook-form";
import DriversServer from "./service/drivers.action";
import GoogleAutocompleteWrapper from "../../../../util/component/GoogleAutocompleteWrapper";
interface Props {
  open: boolean;
  driver: DriversTypes.Drivers;
  onClose: () => void;
  updateDatasourceDamage: () => void;
  //   onReset:()=>void;
  //   formikValues:DamageTypes.FilterDamage;
}

const EditDriver = (props: Props) => {
  const snackbar = useSnackbar();
  const { setLoading } = useContext(ContextOperation);
  const t = useOperationTranslation();
  const { tenant } = useContext(ContextOperation);
  let id = props.driver?.id;
  const onSubmit = () => {
    setLoading(true);
    DriversServer.put.updateDriver(id, tenant, form.getValues()).then(
      () => {
        onClose();
        setLoading(false);
        // if(props.formikValues){
        //   props.onReset();
        // }
        props.updateDatasourceDamage();
        snackbar.show("success", t("drivers.edit.editMessages"));
      },
      (error: any) => {
        onClose();
        setLoading(false);
        snackbar.show("error", t("drivers.edit.editError"));
      }
    );
  };
  const isDisabled = () => {
    let formValues = { ...form.getValues() };
    delete formValues?.fiscalCode;
    delete formValues?.mobile;
    // JSON.stringify(form.getValues()) !== '{}' &&
    return Object.values(formValues).some((x) => x?.trim() == "");
  };

  const form = useForm<DriversTypes.Drivers>({
    defaultValues: {},
  });
  useEffect(() => {
    form.setValue("name", props.driver?.name);
    form.setValue("surname", props.driver?.surname);
    form.setValue("address", props.driver?.address);
    form.setValue("birthDate", props.driver?.birthDate);
    form.setValue("birthNation", props.driver?.birthNation);
    form.setValue("countryResidence", props.driver?.countryResidence);
    form.setValue("residenceAddress", props.driver?.residenceAddress);
    form.setValue("fiscalCode", props.driver?.fiscalCode);
    form.setValue("drivingLicenseNumber", props.driver?.drivingLicenseNumber);
    form.setValue("mobile", props.driver?.mobile);
    form.setValue("sapDriverId", props.driver?.sapDriverId);
  }, [props.open]);
  const onClose = () => {
    props.onClose();
  };

  return (
    <Mui.Dialog open={props.open} onClose={onClose} fullWidth maxWidth="lg">
      <Mui.DialogTitle>
        <Mui.Grid container alignItems="center">
          <Mui.Grid item xs="auto">
            <Mui.Typography variant="h6">
              {t("drivers.edit.title")}
            </Mui.Typography>
          </Mui.Grid>
          <Mui.Grid item xs="auto" marginLeft="auto">
            <Mui.IconButton onClick={onClose}>
              <MuiIcons.Close />
            </Mui.IconButton>
          </Mui.Grid>
        </Mui.Grid>
      </Mui.DialogTitle>
      <Mui.DialogContent>
        <form id="damagePrice-list" onSubmit={form.handleSubmit(onSubmit)}>
          <Mui.Grid container spacing="16px" p={2}>
            <Mui.Grid item md={3} xs={12}>
              <FormInput
                type="text"
                label={t("drivers.fields.surname")}
                name={nameof<DriversTypes.Drivers>("surname")}
                formInstance={form}
                fullWidth
              />
            </Mui.Grid>
            <Mui.Grid item md={3} xs={12}>
              <FormInput
                type="text"
                label={t("drivers.fields.name")}
                name={nameof<DriversTypes.Drivers>("name")}
                formInstance={form}
                fullWidth
              />
            </Mui.Grid>
            <Mui.Grid item md={3} xs={12}>
              <FormInput
                type="text"
                label={t("drivers.fields.fiscalCode")}
                name={nameof<DriversTypes.Drivers>("fiscalCode")}
                formInstance={form}
                fullWidth
              />
            </Mui.Grid>
            <Mui.Grid item md={3} xs={12}>
              <FormInput
                type="date"
                label={t("drivers.fields.birthDate")}
                name={nameof<DriversTypes.Drivers>("birthDate")}
                formInstance={form}
                inputFormat={"DD/MM/YYYY"}
                removeTime={true}
                fullWidth
              />
            </Mui.Grid>
          </Mui.Grid>

          <Mui.Grid container spacing="16px" p={2}>
            <Mui.Grid item md={3} xs={12}>
              <FormInput
                type="text"
                label={t("drivers.fields.address")}
                name={nameof<DriversTypes.Drivers>("address")}
                formInstance={form}
                fullWidth
              />
            </Mui.Grid>
            <Mui.Grid item md={3} xs={12}>
              <FormInput
                type="text"
                label={t("drivers.fields.birthNation")}
                name={nameof<DriversTypes.Drivers>("birthNation")}
                formInstance={form}
                fullWidth
              />
            </Mui.Grid>
            <Mui.Grid item md={3} xs={12}>
              <GoogleAutocompleteWrapper
                googleInputProps={
                  {
                    options: {
                      types: ["address"]
                    },
                    onPlaceSelected: (place: any) => {
                      form.setValue("residenceAddress", place.formatted_address);
                      let country = place.address_components.find((a: any) => a.types.includes("country"))?.long_name;
                      form.setValue("countryResidence", country);
                    }
                  }
                }
                inputProps={
                  {
                    fullWidth: true,
                    label: t("drivers.fields.residenceAddress"),
                    name: `nameof<DriversTypes.Drivers>("residenceAddress")`,
                    type: "text",
                    value: form.watch("residenceAddress") || "",
                    onChange: (e) => {
                      form.setValue("residenceAddress", e.target.value);
                    }
                  }
                }
              />
            </Mui.Grid>
            <Mui.Grid item md={3} xs={12}>
              <FormInput
                type="text"
                label={t("drivers.fields.countryResidence")}
                name={nameof<DriversTypes.Drivers>("countryResidence")}
                formInstance={form}
                fullWidth
              />
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid container spacing="16px" p={2}>
            <Mui.Grid item md={3} xs={12}>
              <FormInput
                type="text"
                label={t("drivers.fields.drivingLicense")}
                name={nameof<DriversTypes.Drivers>("drivingLicenseNumber")}
                disabled
                formInstance={form}
                fullWidth
              />
            </Mui.Grid>
            <Mui.Grid item md={3} xs={12}>
              <FormInput
                type="text"
                label={t("drivers.fields.mobile")}
                name={nameof<DriversTypes.Drivers>("mobile")}
                formInstance={form}
                fullWidth
              />
            </Mui.Grid>
          </Mui.Grid>
        </form>
      </Mui.DialogContent>
      <Mui.DialogActions>
        <Mui.Grid container justifyContent="end" spacing="16px">
          <Mui.Grid item xs="auto" height="48px">
            <Mui.Button
              variant="outlined"
              sx={{ maxWidth: "111px", minWidth: "111px", fontWeight: 700 }}
              onClick={onClose}
            >
              {t(
                "vehicleEquipmentAssociation.dialogs.editAcriss.actions.cancel"
              )}
            </Mui.Button>
          </Mui.Grid>
          <Mui.Grid item xs="auto">
            <Mui.Button
              onClick={() => onSubmit()}
              sx={{ maxWidth: "111px", minWidth: "111px", fontWeight: 700 }}
              disabled={isDisabled()}
            >
              {t("vehicleEquipmentAssociation.dialogs.editAcriss.actions.save")}
            </Mui.Button>
          </Mui.Grid>
        </Mui.Grid>
      </Mui.DialogActions>
    </Mui.Dialog>
  );
};

export default EditDriver;
